module.exports = __webpack_public_path__ + "media/images/digivent/fondo_somtalent2-a2dcc7f98c9cece194746d87a9713bfd.png";